import { Link, useRouteMatch } from "react-router-dom";
import OmniLogo from "../../assets/images/png/OmniLogoNew.png";
import { useDispatch } from "react-redux";
import { setTabData } from "../../redux/programs/ProgramsAction";

import { eventTrack, eventTrackGA4 } from "../../utils/helperFunctions";
import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const Header = () => {
  const dispatch = useDispatch();
  const handleEvent = () => {
    window.open(CONSTANTS.baseUrl, "_blank");
    eventTrack("Redirection To Web Portal", "From login button in header", "Redirection");
    eventTrackGA4("Redirection To Web Portal", "From login button in header", "Redirection");
  };
  const handleFreshlyEvent = () => {
    eventTrack("Redirection To Freshly Website", "From Meal Services button in header", "Redirection");
    eventTrackGA4("Redirection To Freshly Website", "From Meal Services button in header", "Redirection");
  };
  return (
    <div className="header-container">
      <div className="header">
        <Link className="logo-image" to={"/"}>
          <img src={OmniLogo} className="logo-img" alt="website logo" />
        </Link>

        <div className="options">
          <Link
            className={`${
              useRouteMatch({
                path: "/",
                exact: true,
              })
                ? "selected"
                : ""
            } option`}
            to="/"
          >
            Overview
          </Link>

          <Link className={`${useRouteMatch("/newStartHere") ? "selected" : ""} option`} to="/newStartHere">
            New? Start Here
          </Link>

          <Link
            onClick={() => {
              dispatch(setTabData("inperson"));
            }}
            className={`${useRouteMatch("/programs") ? "selected" : ""} option`}
            to="/programs"
          >
            Programs
          </Link>
          <Link className={`${useRouteMatch("/clients") ? "selected" : ""} option`} to="/clients">
            Clients
          </Link>

          <a
            className="option"
            target="_blank"
            href={CONSTANTS.shopUrl}
            rel="noreferrer noopener"
            onClick={handleFreshlyEvent}
          >
            Shop
          </a>
          <Link className={`${useRouteMatch("/updates") ? "selected" : ""} option`} to="/updates">
            Updates
          </Link>
          <Link className={`${useRouteMatch("/careers") ? "selected" : ""} option`} to="/careers">
            Careers
          </Link>
          <Link className={`${useRouteMatch("/contact") ? "selected" : ""} option`} to="/contact">
            Contact
          </Link>
        </div>
        <div className="login-buttons" onClick={handleEvent}>
          Log In
        </div>
      </div>
      <div className="bottom-line" />
    </div>
  );
};

export default Header;
